__turbopack_context__.v({
  "addButton": "Cart-module__Cx-G-G__addButton",
  "addToCart": "Cart-module__Cx-G-G__addToCart",
  "addToCartIcon": "Cart-module__Cx-G-G__addToCartIcon",
  "addToCartText": "Cart-module__Cx-G-G__addToCartText",
  "card": "Cart-module__Cx-G-G__card",
  "cardBox": "Cart-module__Cx-G-G__cardBox",
  "cardImg": "Cart-module__Cx-G-G__cardImg",
  "cardImgBox": "Cart-module__Cx-G-G__cardImgBox",
  "count": "Cart-module__Cx-G-G__count",
  "counterBox": "Cart-module__Cx-G-G__counterBox",
  "deleteButton": "Cart-module__Cx-G-G__deleteButton",
  "discount": "Cart-module__Cx-G-G__discount",
  "discription": "Cart-module__Cx-G-G__discription",
  "divPrise": "Cart-module__Cx-G-G__divPrise",
  "name": "Cart-module__Cx-G-G__name",
  "spanPrise": "Cart-module__Cx-G-G__spanPrise",
});
